<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar />
      </flex-col>
      <flex-col :span="24">
        <async-form :form-data="formData" @submit="log('submit', 'async-form', $event)">
          <card :overflow-off="false">
            <card-title v-html="$lang.asyncFormDemo" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" />
            <card-text>
              <flex :spacing="3">
                <flex-col :span="8" sm24>
                  <dropdown :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" :label-color="$dark ? 'white' : 'black'" :label-color-lightness="null" icon="human-greeting" :label="$lang.title" v-model="formData.title" :items="titles"  />
                </flex-col>
                <flex-col :span="8" sm24>
                  <text-field :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" :label-color="$dark ? 'white' : 'black'" :label-color-lightness="null" icon-left="account" :label="$lang.firstName" :placeholder="$lang.firstName" v-model="formData.firstName" />
                </flex-col>
                <flex-col :span="8" sm24>
                  <text-field :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" :label-color="$dark ? 'white' : 'black'" :label-color-lightness="null" icon-left="account" :label="$lang.lastName" :placeholder="$lang.lastName" v-model="formData.lastName" />
                </flex-col>
                <flex-col :span="12" sm24>
                  <text-field :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" :label-color="$dark ? 'white' : 'black'" :label-color-lightness="null" icon-left="lock" :label="$lang.password" :placeholder="$lang.password" type="password" v-model="formData.password" />
                </flex-col>
                <flex-col :span="12" sm24>
                  <text-field :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" :label-color="$dark ? 'white' : 'black'" :label-color-lightness="null" icon-left="lock" :label="$lang.passwordRepeat" :placeholder="$lang.passwordRepeat" type="password" v-model="formData.passwordRepeat" />
                </flex-col>
                <flex-col :span="24" sm24>
                  <text-field :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" :label-color="$dark ? 'white' : 'black'" :label-color-lightness="null" icon-left="clipboard-text" :label="$lang.comments" :placeholder="$lang.comments" multiline v-model="formData.comments" />
                </flex-col>
                <flex-col :span="24">
                  <container :class="['py-4', 'text-center']">
                    <divider />
                    <radio-group v-model="formData.library" :vertical="false" name="libraries">
                      <radio v-for="(radio, index) in radios" :icon-color="$root.colors.primary" :icon-color-lightness="$root.colors.bgColorLightness" :label="radio" :value="radio" :class="['m-2']" :key="index" />
                    </radio-group>
                    <divider />
                  </container>
                </flex-col>
                <flex-col :span="24">
                  <checkbox :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" :label="$lang.receivePromoEmails" v-model="formData.receivePromoEmails" />
                </flex-col>
                <flex-col :span="24">
                  <checkbox :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" :label="$lang.agreeToProcessPersonalData" v-model="formData.agreeToProcessPersonalData" />
                </flex-col>
              </flex>
            </card-text>
            <divider />
            <card-actions>
              <table-layout>
                <row y-align="middle">
                  <cell x-align="left">
                    <switcher :bg-color="$root.$colors.primary" :bg-color-lightness="$root.$colors.bgColorLightness" :label="$lang.agreeToTos" v-model="formData.agreeToTos" />
                  </cell>
                  <cell x-align="right">
                    <btn plain :color="$root.colors.primary" :color-lightness="null" size="sm" :title="$lang.resetForm">{{ $lang.resetForm }}</btn>
                    <btn size="sm" type="submit" :title="$lang.submitForm" color="white" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness">{{ $lang.submitForm }}</btn>
                  </cell>
                </row>
              </table-layout>
            </card-actions>
            <divider />
            <card-actions align="left">
              <code-chunk :pre="false">form-data: {{ formData }}</code-chunk>
            </card-actions>
          </card>
        </async-form>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageAsyncForm',
  mixins: [
    methods
  ],
  data () {
    return {
      titles: [{
        text: 'Mr.',
        value: 'mr'
      }, {
        text: 'Ms.',
        value: 'ms'
      }, {
        text: 'Mrs.',
        value: 'mrs'
      }],
      radios: ['Vue', 'Angular', 'React'].sort(),
      formData: {
        firstName: null,
        lastName: null,
        password: null,
        passwordRepeat: null,
        title: [],
        comments: null,
        receivePromoEmails: false,
        agreeToProcessPersonalData: false,
        agreeToTos: false,
        library: 'Vue'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/forms/async-form.vue